import moment from 'moment';

export const parseDateWithChrono = (dateString: string): string | null => {
  // Define the possible date formats
  const formats = [
    'MM/DD/YY',         // US short year format (e.g., 10/24/24)
    'MM-DD-YYYY',       // US format with dashes (e.g., 10-24-2024)
    'MM/DD/YYYY',       // US format (e.g., 10/24/2024)
    'M/DD/YYYY',        // US format (e.g., 1/24/2024)
    'MM.DD.YYYY',       // Another ISO format with dots (e.g., 10.24.2024)
    'YYYY-MM-DD',       // ISO 8601 format (e.g., 2024-10-24)
    'YYYY-MM-DDTHH:mm:ss', // ISO format with time (e.g., 2024-10-24T15:30:00)
    'YYYY/MM/DD',       // Alternative ISO format with slashes (e.g., 2024/10/24)
    'YYYY.MM.DD',       // Another ISO format with dots (e.g., 2024.10.24)
    'DD/MM/YYYY',       // European format (e.g., 24/10/2024)
    'DD-MM-YYYY',       // Another European format with dashes (e.g., 24-10-2024)
    'DD.MM.YYYY',       // Another ISO format with dots (e.g., 24.10.2024)
    'DD/MM/YY',         // European short year format (e.g., 24/10/24)
  ];

  // Try each format in the list
  for (const format of formats) {
    const parsed = moment.utc(dateString, format, true); // Use `true` for strict parsing
    if (parsed.isValid()) {
      return parsed.format('YYYY-MM-DD'); // Return in standard format (ISO 8601)
    }
  }

  // If none of the formats work, return the original string
  return null; // or return the dateString if you want to preserve invalid dates
};
